import React from 'react'
import PropTypes from 'prop-types'
import SydInput from '../../../../../commonDesign/SydInput'

const ConnectionFormField = ({ type, ...rest }) => {
  if (type === 'string') {
    return <SydInput size='sm' {...rest} role='presentation' />
  }
  if (type === 'password') {
    return <SydInput size='sm' type='password' {...rest} autoComplete='new-password' role='presentation' />
  }

  return <SydInput {...rest} />
}

ConnectionFormField.propTypes = {
  // eslint-disable-next-line no-undef
  type: PropTypes.oneOf(['string', 'password'])
}

export default ConnectionFormField
